import { render, staticRenderFns } from "./AddNewKpiModal.vue?vue&type=template&id=16cb4682&"
import script from "./AddNewKpiModal.vue?vue&type=script&lang=js&"
export * from "./AddNewKpiModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QForm,QItemLabel,QInput,QSelect,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QForm,QItemLabel,QInput,QSelect,QCardActions,QBtn})
